import './Footer.css.proxy.js';
/* src/components/layout/Footer.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import Wrap from "../slot/Wrap.js";

function create_default_slot(ctx) {
	let div;
	let ul0;
	let li0;
	let a0;
	let t0;
	let li1;
	let a1;
	let t1;
	let li2;
	let a2;
	let t2;
	let li3;
	let a3;
	let t3;
	let li4;
	let a4;
	let t4;
	let ul1;
	let li5;
	let a5;
	let t5;
	let li6;
	let a6;
	let t6;
	let ul2;
	let li7;
	let a7;
	let t7;
	let li8;
	let a8;
	let t8;
	let li9;
	let a9;
	let t9;
	let figure;
	let img;
	let img_src_value;
	let figcaption;
	let t10;
	let p;
	let t11;

	return {
		c() {
			div = element("div");
			ul0 = element("ul");
			li0 = element("li");
			a0 = element("a");
			t0 = text("ホーム");
			li1 = element("li");
			a1 = element("a");
			t1 = text("点検サービス");
			li2 = element("li");
			a2 = element("a");
			t2 = text("スーパーカーレンタル");
			li3 = element("li");
			a3 = element("a");
			t3 = text("企業情報");
			li4 = element("li");
			a4 = element("a");
			t4 = text("求人情報");
			ul1 = element("ul");
			li5 = element("li");
			a5 = element("a");
			t5 = text("車両一覧");
			li6 = element("li");
			a6 = element("a");
			t6 = text("お知らせ");
			ul2 = element("ul");
			li7 = element("li");
			a7 = element("a");
			t7 = text("オンライン接客");
			li8 = element("li");
			a8 = element("a");
			t8 = text("お問い合わせ");
			li9 = element("li");
			a9 = element("a");
			t9 = text("個人情報保護方針");
			figure = element("figure");
			img = element("img");
			figcaption = element("figcaption");
			t10 = text("株式会社アルベロ");
			p = element("p");
			t11 = text("©株式会社アルベロ All rights reserved.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			ul0 = claim_element(div_nodes, "UL", { class: true });
			var ul0_nodes = children(ul0);
			li0 = claim_element(ul0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			a0 = claim_element(li0_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t0 = claim_text(a0_nodes, "ホーム");
			a0_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			li1 = claim_element(ul0_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			a1 = claim_element(li1_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			t1 = claim_text(a1_nodes, "点検サービス");
			a1_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			li2 = claim_element(ul0_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			a2 = claim_element(li2_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			t2 = claim_text(a2_nodes, "スーパーカーレンタル");
			a2_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			li3 = claim_element(ul0_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			a3 = claim_element(li3_nodes, "A", { href: true, class: true });
			var a3_nodes = children(a3);
			t3 = claim_text(a3_nodes, "企業情報");
			a3_nodes.forEach(detach);
			li3_nodes.forEach(detach);
			li4 = claim_element(ul0_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			a4 = claim_element(li4_nodes, "A", { href: true, class: true });
			var a4_nodes = children(a4);
			t4 = claim_text(a4_nodes, "求人情報");
			a4_nodes.forEach(detach);
			li4_nodes.forEach(detach);
			ul0_nodes.forEach(detach);
			ul1 = claim_element(div_nodes, "UL", { class: true });
			var ul1_nodes = children(ul1);
			li5 = claim_element(ul1_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			a5 = claim_element(li5_nodes, "A", { href: true, class: true });
			var a5_nodes = children(a5);
			t5 = claim_text(a5_nodes, "車両一覧");
			a5_nodes.forEach(detach);
			li5_nodes.forEach(detach);
			li6 = claim_element(ul1_nodes, "LI", { class: true });
			var li6_nodes = children(li6);
			a6 = claim_element(li6_nodes, "A", { href: true, class: true });
			var a6_nodes = children(a6);
			t6 = claim_text(a6_nodes, "お知らせ");
			a6_nodes.forEach(detach);
			li6_nodes.forEach(detach);
			ul1_nodes.forEach(detach);
			ul2 = claim_element(div_nodes, "UL", { class: true });
			var ul2_nodes = children(ul2);
			li7 = claim_element(ul2_nodes, "LI", { class: true });
			var li7_nodes = children(li7);
			a7 = claim_element(li7_nodes, "A", { href: true, class: true });
			var a7_nodes = children(a7);
			t7 = claim_text(a7_nodes, "オンライン接客");
			a7_nodes.forEach(detach);
			li7_nodes.forEach(detach);
			li8 = claim_element(ul2_nodes, "LI", { class: true });
			var li8_nodes = children(li8);
			a8 = claim_element(li8_nodes, "A", { href: true, class: true });
			var a8_nodes = children(a8);
			t8 = claim_text(a8_nodes, "お問い合わせ");
			a8_nodes.forEach(detach);
			li8_nodes.forEach(detach);
			li9 = claim_element(ul2_nodes, "LI", { class: true });
			var li9_nodes = children(li9);
			a9 = claim_element(li9_nodes, "A", { href: true, class: true });
			var a9_nodes = children(a9);
			t9 = claim_text(a9_nodes, "個人情報保護方針");
			a9_nodes.forEach(detach);
			li9_nodes.forEach(detach);
			ul2_nodes.forEach(detach);
			div_nodes.forEach(detach);
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figcaption = claim_element(figure_nodes, "FIGCAPTION", { class: true });
			var figcaption_nodes = children(figcaption);
			t10 = claim_text(figcaption_nodes, "株式会社アルベロ");
			figcaption_nodes.forEach(detach);
			figure_nodes.forEach(detach);
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t11 = claim_text(p_nodes, "©株式会社アルベロ All rights reserved.");
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a0, "href", "/");
			attr(a0, "class", "svelte-woud9f");
			attr(li0, "class", "svelte-woud9f");
			attr(a1, "href", "/inspection");
			attr(a1, "class", "svelte-woud9f");
			attr(li1, "class", "svelte-woud9f");
			attr(a2, "href", "/rental");
			attr(a2, "class", "svelte-woud9f");
			attr(li2, "class", "svelte-woud9f");
			attr(a3, "href", "/about");
			attr(a3, "class", "svelte-woud9f");
			attr(li3, "class", "svelte-woud9f");
			attr(a4, "href", "/recruit");
			attr(a4, "class", "svelte-woud9f");
			attr(li4, "class", "svelte-woud9f");
			attr(ul0, "class", "svelte-woud9f");
			attr(a5, "href", "/stock");
			attr(a5, "class", "svelte-woud9f");
			attr(li5, "class", "svelte-woud9f");
			attr(a6, "href", "/news");
			attr(a6, "class", "svelte-woud9f");
			attr(li6, "class", "svelte-woud9f");
			attr(ul1, "class", "svelte-woud9f");
			attr(a7, "href", "/online-service");
			attr(a7, "class", "svelte-woud9f");
			attr(li7, "class", "svelte-woud9f");
			attr(a8, "href", "/contact");
			attr(a8, "class", "svelte-woud9f");
			attr(li8, "class", "svelte-woud9f");
			attr(a9, "href", "/privacy-policy");
			attr(a9, "class", "svelte-woud9f");
			attr(li9, "class", "svelte-woud9f");
			attr(ul2, "class", "svelte-woud9f");
			attr(div, "class", "sitemap svelte-woud9f");
			if (img.src !== (img_src_value = "/images/logo.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "株式会社アルベロ");
			attr(img, "class", "svelte-woud9f");
			attr(figcaption, "class", "svelte-woud9f");
			attr(figure, "class", "svelte-woud9f");
			attr(p, "class", "svelte-woud9f");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, ul0);
			append(ul0, li0);
			append(li0, a0);
			append(a0, t0);
			append(ul0, li1);
			append(li1, a1);
			append(a1, t1);
			append(ul0, li2);
			append(li2, a2);
			append(a2, t2);
			append(ul0, li3);
			append(li3, a3);
			append(a3, t3);
			append(ul0, li4);
			append(li4, a4);
			append(a4, t4);
			append(div, ul1);
			append(ul1, li5);
			append(li5, a5);
			append(a5, t5);
			append(ul1, li6);
			append(li6, a6);
			append(a6, t6);
			append(div, ul2);
			append(ul2, li7);
			append(li7, a7);
			append(a7, t7);
			append(ul2, li8);
			append(li8, a8);
			append(a8, t8);
			append(ul2, li9);
			append(li9, a9);
			append(a9, t9);
			insert(target, figure, anchor);
			append(figure, img);
			append(figure, figcaption);
			append(figcaption, t10);
			insert(target, p, anchor);
			append(p, t11);
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(figure);
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let footer;
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			footer = element("footer");
			create_component(wrap.$$.fragment);
			this.h();
		},
		l(nodes) {
			footer = claim_element(nodes, "FOOTER", { class: true });
			var footer_nodes = children(footer);
			claim_component(wrap.$$.fragment, footer_nodes);
			footer_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(footer, "class", "svelte-woud9f");
		},
		m(target, anchor) {
			insert(target, footer, anchor);
			mount_component(wrap, footer, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(footer);
			destroy_component(wrap);
		}
	};
}

class Footer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Footer;
//# sourceMappingURL=Footer.js.map
